import { callService } from "@Views/utils/ServiceUtils";
import { isEmpty } from "@Views/utils/StringUtils";
import { useRef, useState } from "react";
import { useHistory } from "react-router";

const PwdFindPage1 = ({ msg, history, setPwdFindPageNo, setUserEmail }: any) => {

    const nameRef: any = useRef();
    const emailRef: any = useRef();

    const OSUUD04R01 = async (param: any) => {
        return await callService('OSUUD04R01', param);
    }

    const OBMUD01U05 = async(usrId:string) => {

        var param = {
            usrId : usrId,
            usrTypCd : 'OS'
        }

        return await callService('OBMUD01U05', param);
    }

    const OSUUD06R01 = async(info:any) => {

        return await callService("OSUUD06R01", info)
    }
    
    const onPwdCheck = async () => {

        const usrName = nameRef['current']['value'];
        const usrEmail = emailRef['current']['value'];

        if (isEmpty(usrName) || isEmpty(usrEmail)) {
            alert("이름, E-mail은 필수 입력항목 입니다.");
            return;
        } else {

            const param = {

                usrNm: usrName,
                usrTypCd: 'OS',
                cntctEaddr: usrEmail,
                useYn: 'Y',
                lginUseYn: 'Y'
            }

            const res = await OSUUD04R01(param);

            if (res['sucsYn'] === 'Y') {

                //비밀번호 초기화
                const changePwdRes = await OBMUD01U05(res['usrId']);

                const info = {
                    toId : res['usrId'],
                    map2 : changePwdRes['cnfmPwd']
                }

                //이메일 발송처리
                OSUUD06R01(info);

                setPwdFindPageNo(3);
                setUserEmail(res['cntctEaddr']);
            } else {
                setPwdFindPageNo(2);
            }
        }

    }

    return (
        <>
            <div className="wrap-body" tabIndex={-1}>
                <div className="wrap-body-content">
                    <section className="find-pw">
                        <h2>{msg['findPwd']['passwordFind']}</h2>
                        <div className="pw-body">
                            <fieldset>
                                <div>
                                    <h3>{msg['findPwd']['findPwdTitle']}</h3>
                                    <p dangerouslySetInnerHTML={{__html : msg['findPwd']['findPwdDesc']}}></p>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box">
                                                <input className="form-control" type="text" id="text-name" placeholder={msg['findPwd']['namePlaceholder']} ref={nameRef} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box">
                                                <label htmlFor="text-email"><span className="text-hide">이메일</span></label>
                                                <input className="form-control" type="text" id="text-email" placeholder={msg['findPwd']['emailPlaceholder']} ref={emailRef} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-group">
                                    <button type="button" className="btn negative" onClick={() => history.goBack()}>{msg['cancel']}</button>
                                    <button type="button" className="btn positive" onClick={() => onPwdCheck()}>{msg['confirm']}</button>
                                </div>
                            </fieldset>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}


const PwdFindPage2 = ({ msg, history }: any) => {

    return (
        <>
            <div className="wrap-body" tabIndex={-1}>
                <div className="wrap-body-content">
                    <section className="find-pw">
                        <h2>{msg['findPwd']['passwordFind']}</h2>
                        <div className="pw-body">
                            <div className="find-act-wrap">
                                <div className="find-txt">
                                    <h3>{msg['findPwd']['pwdCheck']}</h3>
                                    <p className="sub-txt">
                                        {msg['findPwd']['pwdCheckDesc']}
                                    </p>
                                </div>
                                <div className="find-result">
                                    <div className="result-txt send-txt">
                                        <p>
                                            {msg['findPwd']['pwdCheckFailMsg']}
                                        </p>
                                    </div>
                                    <div className="result-btn">
                                        <div className="result-btn">
                                            <a className="btn btn-popup negative"  tabIndex={0} onKeyUp={(e)=>e.key==='Enter'&&history.push('/')} onClick={() => history.push('/')}>{msg['findPwd']['main']}</a>
                                            <a className="btn btn-popup positive"  tabIndex={0} onKeyUp={(e)=>e.key==='Enter'&&history.push('/AuthKeyApply')} onClick={() => history.push('/AuthKeyApply')}>{msg['findPwd']['authKeyApply']}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    )
}

const PwdFindPage3 = ({ msg, history, userEmail }: any) => {
    return (
        <>
            <div className="wrap-body" tabIndex={-1}>
                <div className="wrap-body-content">
                    <section className="find-pw">
                        <h2>{msg['findPwd']['passwordFind']}</h2>
                        <div className="pw-body">
                            <div className="find-act-wrap">
                                <div className="find-txt">
                                    <h3>{msg['findPwd']['sendPwd']}</h3>
                                    <p className="sub-txt" dangerouslySetInnerHTML={{__html : msg['findPwd']['sendPwdDesc']}}></p>
                                </div>
                                <div className="find-result">
                                    <div className="result-txt send-txt">
                                        <p>
                                            {msg['findPwd']['sendMsg1']} <span>[{userEmail}]</span> {msg['findPwd']['sendMsg2']}<br />
                                            {msg['findPwd']['sendPwdMsg']}
                                        </p>
                                    </div>
                                    <div className="result-btn">
                                        <div className="result-btn">
                                            <a className="btn btn-popup negative" tabIndex={0} onKeyUp={(e)=>e.key==='Enter'&&history.push('/')} onClick={() => history.push('/')}>{msg['findPwd']['main']}</a>
                                            <a className="btn btn-popup positive" tabIndex={0} onKeyUp={(e)=>e.key==='Enter'&&history.push('/Login')} onClick={() => history.push('/Login')}>{msg['findPwd']['login']}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    )
}

const PasswordFind = ({msg}: any) => {
    const history = useHistory();
    const [pwdFindPageNo, setPwdFindPageNo] = useState<number>(1);
    const [userEmail, setUserEmail] = useState<string>();

    const getPwdFind = () => {

        if (pwdFindPageNo === 1) {
            return <PwdFindPage1 msg={msg} history={history} setPwdFindPageNo={setPwdFindPageNo} setUserEmail={setUserEmail} />
        } else if (pwdFindPageNo === 2) {
            return <PwdFindPage2 msg={msg} history={history} />
        } else if (pwdFindPageNo === 3) {
            return <PwdFindPage3 msg={msg} history={history} userEmail={userEmail} />
        }

    }

    return (
        <>
            {
                getPwdFind()
            }
        </>
    );
}
export default PasswordFind;